

// const frfr_lib_changes_id = '/FRFR/frfr-string-constants.js/changes_id2025-12-07r1/';

/*
FrFr FRIENDLY FRAMEWORK
frfr-smartbom-utils
Version ID: 1a 2025-12-07r1
by 
// Please describe here if you customized this file
*/


// ----- STRING CONSTS

export const str_consts = {};

export const DOT = '.';
export const COMMA = ',';
export const SLASH = '/';
export const MINUS = '-';
export const DOLLAR = '$';
export const SPACE = ' ';


// ----- SPECIAL CHARACTERS

export const TAB_CHARACTER = '\t'; // Unicode Character (U+0009) ISO Name:	<Character Tabulation> (HT, TAB). Formerly:	Character Tabulation
/*
https://symbl.cc/en/0009/
Horizontal Tabulation

The Horizontal Tab symbol was developed to simplify text formatting. It provided a mechanism for automatic alignment in vertical columns on output devices, such as printers and computer terminals.

When it comes to text editors and computer terminals, the Horizontal Tab symbol is typically used to move the cursor to the next fixed tab position. Tabs are pre-defined at equal intervals, such as every 8 characters or any other number set by the user. Horizontal tabs make it easier to align text and structure information in tables.

...

Some formats like TSV use the Tab symbol to divide data. This can be more convenient than using a space or comma, which are pretty common and require special escaping.

...

Escape sequence: \t.

It's one of the eight control symbols, the presence of which is required by POSIX:

...

The symbol “Horizontal Tabulation” is included in the “C0 controls” subblock of the “Basic Latin” block and was approved as part of Unicode version 1.1 in 1993.

Synonyms
HT, TAB.

Technical Information

Unicode Name	Horizontal Tabulation
Unicode Number	U+0009
HTML Code	&#9;
CSS Code	\0009
Plane	0: Basic Multilingual Plane
Unicode Block	Basic Latin
Unicode Subblock	C0 controls
Unicode Version	1.1 (1993)
Keyboard shortcut	^I
Escape sequences	\t

*/

/*
https://en.wikipedia.org/wiki/Control_character
Control character
Non-printable character" redirects here.

In computing and telecommunications, a control character or non-printing character (NPC) is a code point in a character set that does not represent a written character or symbol. They are used as in-band signaling to cause effects other than the addition of a symbol to the text. All other characters are mainly graphic characters, also known as printing characters (or printable characters), except perhaps for "space" characters. In the ASCII standard there are 33 control characters, such as code 7, BEL, which rings a terminal bell.
*/

/*
https://en.wikipedia.org/wiki/POSIX
*/

export const NEW_LINE_RN = '\r\n'; // TODO: odluciti se kasnije da li se koristi ovaj ili \n ili \r\n
export const NEW_LINE_N = '\n'; // TODO: odluciti se kasnije da li se koristi ovaj ili \n ili \r\n
export const NEW_LINE_R = '\r'; // TODO: odluciti se kasnije da li se koristi ovaj ili \n ili \r\n

export const NEW_LINE = NEW_LINE_RN; // DEFAULT


// ----- SPECIAL CHARACTERS
/*
https://developer.mozilla.org/en-US/docs/Glossary/Character_reference
https://www.php.net/manual/en/function.htmlspecialchars.php
https://www.w3schools.com/charsets/ref_html_entities_4.asp
https://en.wikipedia.org/wiki/Non-breaking_space

*/
/*
Character	Named reference	Unicode code-point
&	&amp;	U+00026
<	&lt;	U+0003C
>	&gt;	U+0003E
"	&quot;	U+00022
'	&apos;	U+00027
&nbsp;	U+000A0
–	&ndash;	U+02013
—	&mdash;	U+02014
©	&copy;	U+000A9
®	&reg;	U+000AE
™	&trade;	U+02122
≈	&asymp;	U+02248
≠	&ne;	U+02260
£	&pound;	U+000A3
€	&euro;	U+020AC
°	&deg;	U+000B0

Character	Replacement
& (ampersand)	&amp;
" (double quote)	&quot;, unless ENT_NOQUOTES is set
' (single quote)	&#039; (for ENT_HTML401) or &apos; (for ENT_XML1, ENT_XHTML or ENT_HTML5), but only when ENT_QUOTES is set
< (less than)	&lt;
> (greater than)	&gt;
*/
export const html_consts = {};
html_consts.NON_BREAKING_SPACE = '&nbsp;'; // non-breaking space // https://en.wikipedia.org/wiki/Non-breaking_space
html_consts.AMPERSAND = '&amp;'; // &
html_consts.LT = '&lt;'; // less than
html_consts.GT = '&gt;'; // greater than
html_consts.DOUBLE_QUOTE = '&quot;';
html_consts.SINGLE_QUOT = '&apos;';
html_consts.COPYRIGHT_C = '&copy;';
html_consts.DEG = '&deg;';
html_consts.SUP_2 = '&sup2;'; // ²
html_consts.SUP_3 = '&sup3;'; // ³
html_consts.TIMES = '&times;'; // × multiplication sign


// ----- Input tyoe file accept
export const ACCEPT_FILE_TYPES_JSON = "application/JSON,application/json,.json";
export const ACCEPT_FILE_TYPES_EXCEL = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
export const ACCEPT_FILE_TYPES_CSV = ".csv";
// http://www.iana.org/assignments/media-types/media-types.xhtml
// const ACCEPT_FILE_TYPES_XML = "text/xml,.xml";
export const ACCEPT_FILE_TYPES_XML = ".xml";
export const ACCEPT_FILE_TYPES_TXT = ".txt";
export const ACCEPT_FILE_TYPES_IMG = "image/*";
export const ACCEPT_FILE_TYPES_IMG_JPG_PNG = "image/jpeg, image/png";


// ----- Content-Type
// https://developer.mozilla.org/en-US/docs/Web/HTTP/Reference/Headers/Content-Type

// <UniCmd>{`Content-Type: application/json; charset=utf-8`}</UniCmd>
export const CONTENT_TYPE_JSON = 'application/json';
export const CONTENT_TYPE_JSON_UTF8 = 'application/json;charset=utf-8';
// "application/x-www-form-urlencoded"
// contentType:"application/x-www-form-urlencoded; charset=UTF-8"
export const CONTENT_TYPE_URLENCODED = 'application/x-www-form-urlencoded';
export const CONTENT_TYPE_URLENCODED_UTF8 = 'application/x-www-form-urlencoded;charset=UTF-8';
// multipart/form-data
// <form action="/foo" method="post" enctype="multipart/form-data">
export const CONTENT_TYPE_MULTIPART = 'multipart/form-data';
// Content-Type: text/html; charset=utf-8
export const CONTENT_TYPE_HTML = 'text/html;charset=utf-8';

